import { useState, useEffect, useCallback } from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import dayjs from "dayjs";
import axiosInstance from "../../../api/axios";
import UserTable from "../table/UserTable";
import { notifyError } from "../../../components/common/toast/ToastFunc";

const UserList = (props) => {

  const { isEmployeeUserList } = props;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reFetch, setReFetch] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [userType, setUserType] = useState("All");

  const theme = useTheme();

  const formatData = useCallback((data) => {
    try {

      const formattedData = data?.map(item => {
        return {
          ...item,
          id: item?.id.replace(/-/g, ""),
          role: item?.role.charAt(0).toUpperCase() + item?.role.slice(1).toLowerCase(),
          dob: dayjs(item?.dob).format('MM/DD/YYYY'),
        };
      });
      setData(formattedData);
    } catch (error) {
      notifyError(error.message || "Something went wrong");
    }
  }, []);

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        const response = await axiosInstance.get('/customer/user-info/get-all', {
          params: {
            type: isEmployeeUserList ? "All" : userType
          }
        });
        formatData(response.data?.data);
      } catch (error) {
        notifyError(error.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formatData, reFetch, userType]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", my: 3 }}>
      <Typography variant="h5" sx={{ mb: 2, color: theme.mainColor }}>User List</Typography>
      <UserTable
        data={data}
        loading={loading}
        actionLoading={actionLoading}
        setActionLoading={setActionLoading}
        reFetch={reFetch}
        setReFetch={setReFetch}
        userType={userType}
        setUserType={setUserType}
        isEmployeeUserList={isEmployeeUserList}
      />
    </Box>
  );
};

export default UserList;
